t = require('views/internal/teacup-with-helpers')('manage_members')
getExperiment = require 'lib/experiments/simple-test'

module.exports = t.renderable ({ canInviteMembers, placeholder, disableAddingExternalMembers, isBCOrgAdmin, orgSettingsURL, canAddMembers, orgName, isPerUser, isMonthly, isYearly, perUserPrice, orgMemsView }) ->
  orgName ?= ""
  adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

  if canInviteMembers
    t.div '.search-with-spinner', ->
      t.input '.js-search-input.js-autofocus', { type: 'text', style: 'margin-bottom: 0;', placeholder }
      t.div '.spinner.small.hide.js-loading'

    t.div '.pop-over-section.js-helper', ->
      t.p '.u-bottom.quiet', { style: 'padding: 6px;' }, ->
        t.format 'search-for-a-person-in-trello-by-name-or-email-address-or-enter-an-email-address-to-invite-someone-new'

  if disableAddingExternalMembers
    t.div '.search-with-spinner', ->
      t.input '.js-search-input.js-autofocus', { type: 'text', style: 'margin-bottom: 0;', placeholder }
      t.div '.spinner.small.hide.js-loading'
    t.p '.warning', ->
      if isBCOrgAdmin
        t.format 'only-organization-members-can-be-added-to-this-board-to-change-this-visit-the-organization-settings-page-and-click-inviting-non-org-members-to-boards', { orgSettingsURL }
      else
        t.format 'only-organization-members-can-be-added-to-this-board-check-with-an-organization-admin-to-change-this-setting'

  t.div '.pop-over-section.hide.js-board-members', ->
    t.ul '.pop-over-member-list.options.js-list'

  t.div '.pop-over-section.hide', ->
    t.h4 ->
      t.format 'error'
    t.p '.error', ->
      t.format 'the-user-or-email-could-not-be-invited-due-to-an-organization-restriction'

  t.div '.pop-over-section.hide.js-error', ->
    t.p '.error', { style: 'margin: 16px 8px 6px;' }

  if canAddMembers
    t.div '.pop-over-section.hide.js-uninvited-search-results'

    t.div '.pop-over-section.hide.js-search-results', ->
      t.h4 ->
        t.format 'select-to-add'
      t.ul '.pop-over-member-list.options.js-list'

    t.div '.pop-over-section.hide.js-no-results', ->
      t.p '.quiet.empty.u-text-align-center', { style: 'padding: 16px 4px;' }, ->
        t.format 'no-results'

    t.div '.pop-over-section.hide.js-org-members', ->
      t.h4 ->
        t.format 'orgname-members', { orgName }
      t.ul '.pop-over-member-list.options.u-clearfix.js-list',
        class: t.classify
          collapsed: orgMemsView
        style: t.stylify
          'margin-bottom': if orgMemsView then '8px' else undefined
      t.a '.quiet-button.js-add-all-org-members', { href: '#', style: 'margin-top: 8px;' }
      t.a '.quiet-button.js-more-org-members.hide', { href: '#', style: 'margin-top: 8px;' }, ->
        t.format 'view-all-members'

  if canInviteMembers && !adsLayoutExperimentEnabled
    t.div '.js-upgrade-team'

  if isPerUser
    t.hr()

    t.p '.quiet.u-bottom', { style: 'padding: 6px;' }, ->
      if isMonthly
        t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-month', { jpsPrice: perUserPrice }
      if isYearly
        t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-year', { jpsPrice: perUserPrice }

  if canInviteMembers
    t.hr()

    t.a '.quiet-button.js-show-invitation-link', { href: '#' }, ->
      t.format 'you-can-also-invite-people-by-giving-them-a-special-link'

    t.div '.manage-member-invitation-link.hide.js-invitation-link-container', ->
      t.p ->
        t.format 'anyone-you-share-this-link-with-will-be-able-to-join'

      t.input '.js-invitation-link',
        type: 'text'
        readonly: 'readonly'
        placeholder: t.l 'loading'

      t.a '.quiet-button.js-deactivate-link', { href: '#' }, ->
        t.format 'disable-this-link'

  if canInviteMembers && adsLayoutExperimentEnabled
    t.hr()
    t.div '.js-upgrade-team'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/manage_members.coffee